import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import NotFound from '../../pages/NotFound/NotFound';
import Home from '../../pages/Home/Home';
import Layout from '../Layout/Layout';
import { Programa } from '../../pages/Programa';
import Area from '../../pages/Area';
import { Admin } from '../../pages/Admin';

const App = () => {
  return (
    <Router>
      <Layout>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/area/:area" component={Area} />
          <Route
            exact
            path="/area/:area/programa/:programa"
            component={Programa}
          />
          <Route exact path="/admin" component={Admin} />
          <Route path="/404" component={NotFound} />
          <Redirect from="*" to="/404" />
        </Switch>
      </Layout>
    </Router>
  );
};

export default App;
